import React from 'react';
import cx from 'clsx';

import type { StatusType } from '~/app/common/components/Product/ProductImage';

type Props = {
  isOutOfStock?: boolean;
  type?: 'wideList' | 'grid' | 'list';
  status?: StatusType;
  className?: string;
};

const TYPO_BY_TYPE: Record<NonNullable<Props['type']>, string> = {
  wideList: 'typo-paragraph200-semibold',
  list: 'typo-footnote300-semibold',
  grid: 'typo-paragraph100-semibold',
};

export function ProductDisabledImageOverlay({
  isOutOfStock,
  type = 'wideList',
  status = 'DISPLAYING',
  className,
}: Props) {
  const classNames = cx(
    'absolute inset-0 flex items-center justify-center whitespace-pre-line text-center text-inverse bg-[hsl(0deg_0%_11%/50%)]',
    TYPO_BY_TYPE[type],
    className,
  );

  if (isOutOfStock) {
    return <div className={classNames}>임시품절</div>;
  }

  if (status === 'READY_FOR_DISPLAY') {
    return <div className={classNames}>상품 준비중</div>;
  }

  if (status === 'DISPLAY_EXPIRED' || status === 'HIDED') {
    return <div className={classNames}>일시 품절</div>;
  }

  if (status !== 'DISPLAYING') {
    return <div className={classNames}>판매중지</div>;
  }

  return null;
}
